(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["beast-korge-krpc-client"] = factory();
	else
		root["beast-korge-krpc-client"] = factory();
})(globalThis, () => {
return 